<template>
  <router-link
    :to="{name: 'mesa_info', params: {mesaId: mesaId}}"
  >{{text}}</router-link>
</template>

<script>
export default {
  name: 'MesaLink',

  props: {
    mesaId: {
      type: Number,
      required: true,
    },

    label: {
      type: String,
      default: 'mesa',
    }
  },

  computed: {
    /** @returns {string} */
    text() {
      const label = this.label;
      const idStr = this.mesaId.toString();

      if(label.length > 0) {
        return label + ' ' + idStr;
      } else {
        return idStr;
      }
    },
  },
};
</script>
